import uuid from "uuid/v4";
import {
  ADD_SAMPLE_TO_CART,
  DECREASE_SAMPLE_QUANTITY,
  DELETE_SAMPLE_FROM_CART,
  DELETE_ALL_SAMPLES_FROM_CART,
} from "../actions/sampleCartActions";

const initState = [];

const sampleCartReducer = (state = initState, action) => {
  const sampleCartItems = state,
    product = action.payload;

  if (action.type === ADD_SAMPLE_TO_CART) {
    // for non variant products
    if (product.variation === undefined) {
      const cartItem = sampleCartItems.filter(
        (item) => item.id === product.id
      )[0];
      if (cartItem === undefined) {
        return [
          ...sampleCartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid(),
          },
        ];
      } else {
        return sampleCartItems.map((item) =>
          item.cartItemId === cartItem.cartItemId
            ? {
                ...item,
                quantity: product.quantity
                  ? item.quantity + product.quantity
                  : item.quantity + 1,
              }
            : item
        );
      }
      // for variant products
    } else {
      const cartItem = sampleCartItems.filter(
        (item) =>
          item.id === product.id &&
          product.selectedProductColor &&
          product.selectedProductColor === item.selectedProductColor &&
          product.selectedProductSize &&
          product.selectedProductSize === item.selectedProductSize &&
          (product.cartItemId ? product.cartItemId === item.cartItemId : true)
      )[0];

      if (cartItem === undefined) {
        return [
          ...sampleCartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid(),
          },
        ];
      } else if (
        cartItem !== undefined &&
        (cartItem.selectedProductColor !== product.selectedProductColor ||
          cartItem.selectedProductSize !== product.selectedProductSize)
      ) {
        return [
          ...sampleCartItems,
          {
            ...product,
            quantity: product.quantity ? product.quantity : 1,
            cartItemId: uuid(),
          },
        ];
      } else {
        return sampleCartItems.map((item) =>
          item.cartItemId === cartItem.cartItemId
            ? {
                ...item,
                quantity: product.quantity
                  ? item.quantity + product.quantity
                  : item.quantity + 1,
                selectedProductColor: product.selectedProductColor,
                selectedProductSize: product.selectedProductSize,
              }
            : item
        );
      }
    }
  }

  if (action.type === DECREASE_SAMPLE_QUANTITY) {
    if (product.quantity === 1) {
      const remainingItems = (sampleCartItems, product) =>
        sampleCartItems.filter(
          (cartItem) => cartItem.cartItemId !== product.cartItemId
        );
      return remainingItems(sampleCartItems, product);
    } else {
      return sampleCartItems.map((item) =>
        item.cartItemId === product.cartItemId
          ? { ...item, quantity: item.quantity - 1 }
          : item
      );
    }
  }

  if (action.type === DELETE_SAMPLE_FROM_CART) {
    const remainingItems = (sampleCartItems, product) =>
      sampleCartItems.filter(
        (cartItem) => cartItem.cartItemId !== product.cartItemId
      );
    return remainingItems(sampleCartItems, product);
  }

  if (action.type === DELETE_ALL_SAMPLES_FROM_CART) {
    return sampleCartItems.filter((item) => {
      return false;
    });
  }

  return state;
};

export default sampleCartReducer;
